import deepcopy from 'deepcopy';

export const vowels = [
  {val: 'A', score: 0, vowel: true, freq: 9},
  {val: 'E', score: 0, vowel: true, freq: 9},
  {val: 'I', score: 0, vowel: true, freq: 6},
  {val: 'O', score: 0, vowel: true, freq: 6},
  {val: 'U', score: 0, vowel: true, freq: 3},
];

export const letters = [
  {val: 'T', score: 2, vowel: false, freq: 5},
  {val: 'N', score: 2, vowel: false, freq: 5},
  {val: 'S', score: 2, vowel: false, freq: 5},
  {val: 'R', score: 2, vowel: false, freq: 5},

  {val: 'H', score: 3, vowel: false, freq: 4},
  {val: 'D', score: 3, vowel: false, freq: 4},
  {val: 'L', score: 3, vowel: false, freq: 4},
  {val: 'C', score: 3, vowel: false, freq: 4},
  {val: 'M', score: 3, vowel: false, freq: 4},
  {val: 'F', score: 3, vowel: false, freq: 4},

  {val: 'Y', score: 4, vowel: false, freq: 3},
  {val: 'W', score: 4, vowel: false, freq: 3},
  {val: 'G', score: 4, vowel: false, freq: 3},
  {val: 'P', score: 4, vowel: false, freq: 3},
  {val: 'B', score: 4, vowel: false, freq: 3},
  {val: 'V', score: 4, vowel: false, freq: 3},
  {val: 'K', score: 4, vowel: false, freq: 3},

  {val: 'X', score: 5, vowel: false, freq: 2},
  {val: 'Q', score: 5, vowel: false, freq: 2},
  {val: 'J', score: 5, vowel: false, freq: 2},
  {val: 'Z', score: 5, vowel: false, freq: 2},
];

export const blank = {val: '', score: 0, vowel: false, freq: 0};

// @TODO Combine code.

export function getVowel() {
  const max = vowels.reduce((acc, vowel) => acc + vowel.freq, 0);
  let val = Math.floor(Math.random() * max);
  let index = 0;
  let vowel = vowels[index];
  while (val >= vowel.freq) {
    val -= vowel.freq;
    index += 1;
    vowel = vowels[index];
  }
  return vowel;
};

export function getLetterSet() {
  return deepcopy(letters);
}

export function getLetter(initialSet=undefined) {
  const mutable = initialSet;
  const letterSet = initialSet ? initialSet : letters;
  const max = letterSet.reduce((acc, letter) => acc + letter.freq, 0);
  let val = Math.floor(Math.random() * max);
  let index = 0;
  let letter = letterSet[index];
  while (val >= letter.freq) {
    val -= letter.freq;
    index += 1;
    letter = letterSet[index];
  }
  if (mutable) {
    letter.freq = Math.max(letter.freq - 2, 0);
  }
  return letter;
};
